import { render, staticRenderFns } from "./EditPriceModal.vue?vue&type=template&id=377d35c0"
import script from "./EditPriceModal.vue?vue&type=script&lang=js"
export * from "./EditPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports